/* eslint-disable @typescript-eslint/no-explicit-any */
import MiiaFwConfig from '@/configs/config'
import { ERROR_CODES } from '@/constants/error/errorCode'
import { ERROR_MESSAGES } from '@/constants/error/errorMessage'
import { useApiGw } from '@/features/miiaFw/composables/useApiGw'
import type { ApiRequest } from '@/types/api/common/apiRequest'
import type {
  GetAerialAreaRequest,
  GetAerialAreasResponse,
  GetOverheadImageRequest,
  GetOverheadImageResponse
} from '@/types/api/geoAerialPhoto/geoAerialPhotoTypes'

export const geoAerialPhotoApi = () => {
  /**
   * getAerialAreaファンクション実行
   * @param params リクエストパラメータ
   * @returns 実行結果
   */
  const getAerialArea = async (params: GetAerialAreaRequest): Promise<GetAerialAreasResponse> => {
    const request: ApiRequest<GetAerialAreaRequest> = {
      function: 'getAerialArea',
      params: params
    }
    return await callGeoAerialPhoto(request)
  }

  /**
   * getOverheadImageファンクション実行
   * @param params リクエストパラメータ
   * @returns 実行結果
   */
  const getOverheadImage = async (
    params: GetOverheadImageRequest
  ): Promise<GetOverheadImageResponse> => {
    const request: ApiRequest<GetAerialAreaRequest> = {
      function: 'getOverheadImage',
      params: params
    }
    return await callGeoAerialPhoto(request)
  }

  /**
   * geoAerialPhoto Lambda実行
   * @param request リクエストパラメータ
   * @returns 実行結果
   */
  const callGeoAerialPhoto = async <T, R>(request: ApiRequest<T>): Promise<R> => {
    return await new Promise((resolve, reject) => {
      useApiGw().invokeApiGwFunc(
        // API Gatewayのエンドポイント
        MiiaFwConfig.config.apiGwEndpointScreening,
        // Lambda関数をコールするためのWebAPIのサブディレクトリ
        '/geoAerialPhoto',
        // Lambda関数に渡す引数
        {
          function: request.function,
          params: {
            ...request.params,
            system: MiiaFwConfig.config.sysId
          }
        },
        // Lambda関数実行前の前処理のコールバック
        () => {},
        // 成功時のコールバック
        (response: R) => {
          resolve(response)
        },
        // 例外受信時のコールバック(引数: エラーメッセージ)
        (message: any) => {
          reject({ message: message })
        },
        // 予期せぬエラー(アクセス回線障害など)発生時のコールバック
        () => {
          reject({ message: ERROR_MESSAGES[ERROR_CODES.API_EXECUTION_FAILED].message })
        },
        // 処理完了後に実行するコールバック
        () => {},
        // ローディングアイコン
        false
      )
    })
  }

  return {
    getAerialArea,
    getOverheadImage
  }
}
